// components/Dropdown.tsx
import React from 'react'
import { useAtom } from 'jotai'
import { Box, FormControl, InputLabel, Select, MenuItem } from '@mui/material'
import type { PrimitiveAtom } from 'jotai'

type DropdownOption = string | { value: string; label: string };

interface DropdownProps {
    stageAtom: PrimitiveAtom<string | null>;
    options: readonly DropdownOption[];
    label: string;
};

const toOption = (opt: DropdownOption) =>
    typeof opt === 'string' ? { value: opt, label: opt } : opt;

export const Dropdown: React.FC<DropdownProps> = ({ stageAtom, options, label }) => {
    const [selected, setSelected] = useAtom(stageAtom);

    return (
        <Box width={200} >
            <FormControl fullWidth >
                <InputLabel id={`${label}-select-label`}> {label} </InputLabel>
                <Select
                    labelId={`${label}-select-label`}
                    value={selected ?? ''}
                    label={label}
                    onChange={e => setSelected(e.target.value as string)}
                >
                    <MenuItem value="" disabled > 選択してください </MenuItem>
                    {
                        options
                            .map(toOption)
                            .map(({ value, label: optLabel }) => (
                                <MenuItem key={value} value={value} >
                                    {optLabel}
                                </MenuItem>
                            ))
                    }
                </Select>
            </FormControl>
        </Box>
    );
};

